import React from "react";
import { Container, Row, Col, Button, ButtonGroup } from "react-bootstrap";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";

export default function Paymentmethod() {
  return (
    <section className="Paymentmethod-main">
      <Container>
        <div className="paymentmethod-here">
          <div className="DigitalArtcollection-head text-center">
            <h2>Buy by Card</h2>
            <p>
              Choose one of available wallet providers or create a new Payment.
              What is a Fiat Currency?
            </p>
          </div>

          <div className="methdo-box">
            <Row>
              <Col lg={6} md={12} sm={12}>
                <div className="paymentbox">
                  <div className="card-details">
                    <img
                      src="images/cardicon.png"
                      alt=""
                      className="img-fluid cardicon"
                    />

                    <p>**** 8295</p>
                  </div>
                  <Button>Change</Button>
                </div>
              </Col>

              <Col lg={6} md={12} sm={12}>
                <div className="paymentbox">
                  <div className="card-details">
                    <img
                      src="images/mastercard.png"
                      alt=""
                      className="img-fluid "
                    />

                    <p>**** 8295</p>
                  </div>
                  <Button>Change</Button>
                </div>
              </Col>

              <Col lg={6} md={12} sm={12}>
                <div className="radiocheckbox position-relative">
                  <Form>
                    <FormGroup check>
                      <Label check>
                        <Input type="radio" name="radio1" /> Credit / Debit /
                        ATM Card
                      </Label>
                    </FormGroup>
                  </Form>
                  <div className="arrowleft">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="13"
                      viewBox="0 0 8 13"
                      fill="none"
                    >
                      <path
                        d="M0 1.5L1.5 0L8 6.5L1.5 13L0 11.5L5 6.5L0 1.5Z"
                        fill="black"
                        fill-opacity="0.25"
                      />
                    </svg>
                  </div>
                </div>
              </Col>

              <Col lg={6} md={12} sm={12}>
                <Button className="radiocheckbox add-new position-relative">
                  <img src="images/addnew.png" alt="" className="img-fluid" />
                  <h6>Add a new card</h6>
                </Button>
              </Col>
            </Row>
            <div className="proceed-checkout">
              <Button className="proceed-to-check">Process to Checkout</Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
